module.exports = __webpack_public_path__ + "img/bruno-mars.1efa95f2.jpg";